import { render } from "./component-ecp.vue?vue&type=template&id=53c2a4f5"
import script from "./component-ecp.vue?vue&type=script&setup=true&lang=js"
export * from "./component-ecp.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-ecp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53c2a4f5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53c2a4f5', __exports__)) {
    api.reload('53c2a4f5', __exports__)
  }
  
  module.hot.accept("./component-ecp.vue?vue&type=template&id=53c2a4f5", () => {
    api.rerender('53c2a4f5', render)
  })

}


export default __exports__